import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { get, set } from "lodash";
import { produce } from "immer";
import { Input, InputProps, Popover, Whisper } from "rsuite";

import PopoverCell from "components/Common/PopoverCell/PopoverCell";

import "./EditableCell.less";

interface Props {
    rowData: Record<string, any>;
    dataKey: string;
    errorMessage?: string | null;

    onChange?: (value: Record<string, any>) => void;
}

const EditableCell: React.FC<Props> = ({
    dataKey,
    rowData,
    errorMessage,
    onChange,
}: Props) => {
    const { t } = useTranslation();

    const [value, setValue] = useState<string>(
        get(rowData, dataKey, t(`unknown`)) ?? t(`unknown`)
    );

    const handleChange: InputProps["onChange"] = (value) => {
        const updatedData = produce(rowData, (draft) => {
            set(draft, dataKey, value);

            return draft;
        });

        setValue(value);

        onChange?.(updatedData);
    };

    const errorPopover = useMemo(
        () => (
            <Popover className="editable-cell__error-text">
                {errorMessage}
            </Popover>
        ),
        [errorMessage]
    );

    return (
        <>
            {rowData.editing ? (
                <Whisper
                    trigger="none"
                    placement={"bottom"}
                    open={!!errorMessage}
                    speaker={errorPopover}
                >
                    <Input type="text" value={value} onChange={handleChange} />
                </Whisper>
            ) : (
                <PopoverCell dataKey={dataKey} rowData={rowData} />
            )}
        </>
    );
};

export default EditableCell;
